export const MixinGetUserData = {
  data () {
    return {
      seznamNarocnin: []
    }
  },
  methods: {
    GetSeznamNarocnin (forced) {
      if (this.seznamNarocnin.length === 0 || forced === true) {
        this.seznamNarocnin = []
        let param = ['permissionId=STRANKE']
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetSeznamNarocnin',
          'ErrSeznamNarocnin')
      }
    },
    SetSeznamNarocnin (podatki) {
      let narocnine = podatki.permission.additionalData
      if (narocnine !== null) {
        this.seznamNarocnin = narocnine
      }
      if (this.seznamNarocnin.length > 0) {
        for (let i = 0; i < this.seznamNarocnin.length; i++) {
          let seznObj = this.seznamNarocnin[i]
          this.seznamNarocnin[i].izbranSap = seznObj.id_stranka_sap +
            ' - ' + seznObj.ime_priimek_kontakt +
            ' - ' + seznObj.naslov
        }
        this.izbranSap = this.seznamNarocnin[0].id_stranka_sap
        this.izbranId = this.seznamNarocnin[0].id_stranka
      }
    },
    ErrSeznamNarocnin (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/PridobitevUporabniskihPodatkovGlobalno/PridobitevUporabniskihPodatkov.js